import React, { useEffect, useState } from "react";
import { Button, PlusIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useRequestHandler from "~/shared/hooks/useRequestHandler";
import Wrapper from "~/shared/ui/Wrapper";
import { useEmployee } from "~/entity/Employee";
import { useSetLocationData } from "~/hooks/locationData";
import { positionsAndTrainingProgramsTableHeader } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";
import { usePermissions } from "~/shared/context/PermissionContext";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import { TableV2 } from "~/shared/ui/TableV2";
import {
  AddEducationalProgram,
  TAddEducationalProgramForm,
} from "~/widgets/Modals/AddEducationalProgram";

import { getEditorPATPColumns } from "./model/tableAdapter";

import s from "./EditorPositionsAndTrainingPrograms.less";

const EditorPositionsAndTrainingPrograms = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const isView = history.location.pathname.includes("/editor/cep/view/ptp");

  const { hasPermission } = usePermissions();
  const { getEducationPrograms } = useEmployee();
  const setData = useSetLocationData();
  const [programs, setPrograms] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getEducationPrograms({
      actualOn: dateFormat(new Date(), { type: "date-special" }),
    })
      .then((res) => {
        setPrograms(get(res, "data.programs", []));
      })
      .finally(() => setLoading(false));
  }, []);

  const isAccessToEditButton = hasPermission(
    "employeeAccounting.curriculum.program.update",
  );

  const { setEducationPrograms } = useEmployee();
  const { requestWithNotifHandler } = useRequestHandler();

  const onAdd = () => setData("openChildModal", "addEducationalProgram");

  const goBack = () => {
    if (isView) {
      window.close();
    } else {
      history.replace("/editor/cep");
    }
  };

  const onEducationalProgramCreate = async (
    value: TAddEducationalProgramForm,
  ) => {
    requestWithNotifHandler({
      request: () =>
        setEducationPrograms({
          positionIds: value.position.map((el) => Number(el)),
          levels: [],
        }),
      callback: ({ instanceId }) => {
        history.push(`/editor/cep/ptp/${instanceId}`);
      },
    });
  };

  const handleRowEdit = (record: { instanceId?: string | number }) => {
    history.push(`/editor/cep/ptp/${record.instanceId}`);
  };

  const handleViewDetails = (record: { instanceId?: string | number }) => {
    history.push(`/editor/cep/view/ptp/${record.instanceId}`);
  };

  return (
    <Wrapper.Content
      title={t("patp.main_page")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
      controlComponent={
        <Flex gap={10}>
          {hasPermission("employeeAccounting.curriculum.program.create") &&
            !isView && (
              <Button
                onClick={onAdd}
                size={"middle"}
                icon={<PlusIcon size={16} />}
              >
                {t("ui.add")}
              </Button>
            )}
        </Flex>
      }
    >
      <TableV2
        columns={getEditorPATPColumns(
          t,
          positionsAndTrainingProgramsTableHeader,
        )}
        loading={loading}
        dataSource={programs}
        rowKey={(record) => record.instanceId}
        onViewDetails={
          isView || !isAccessToEditButton ? handleViewDetails : undefined
        }
        onRowEdit={isView || !isAccessToEditButton ? undefined : handleRowEdit}
        wrapperClassName={s.editor_table}
      />
      <AddEducationalProgram onSubmit={onEducationalProgramCreate} />
    </Wrapper.Content>
  );
};

export default EditorPositionsAndTrainingPrograms;
